{
	"title": "Comments",
	"attachmentsBy": "Attachments from {{author}} · {{date}}",
	"statuses": {
		"inValidation": "In Validation",
		"rejected": "Rejected",
		"assured": "Assured",
		"flagged": "Flagged",
		"resolved": "Resolved"
	}
}
